import { useCallback, useMemo } from "react";
import { Menu, Dropdown } from "antd";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import { ROUTES } from "utils/constants";

import { actionMenu } from "svgs";
import { VehiclesState } from "types/store";
import { getVehicle, setModalName, setSelectedVehicle } from "store/actions";
import {AppState} from "../../../store";

export default function DropdownAction({
  vehicle,
}: {
  vehicle: VehiclesState["selectedVehicle"];
}) {
  const dispatch = useDispatch();
  const {
      common:{userType=1}
  } = useSelector<AppState, AppState>((state) => state);

  const history = useHistory();

  const onEditShift = useCallback((e) => {
    e.domEvent.stopPropagation(); 
    dispatch(setSelectedVehicle(vehicle));
    dispatch(setModalName("edit_vehicle"));
  }, [dispatch, vehicle]);

  const onDelete = useCallback((e) => {
    e.domEvent.stopPropagation(); 
    dispatch(setSelectedVehicle(vehicle));
    dispatch(setModalName("delete_vehicle"));
  }, [dispatch, vehicle]);
 
  const onVehicleDetail = useCallback((e) => {
    e.domEvent.stopPropagation();
    console.log('Vehicle ID:', vehicle?.id);
    console.log('Navigation URL:', `${ROUTES.vehicle_detail}/${vehicle?.id}`);
    dispatch(setSelectedVehicle(vehicle));
    history.push(`${ROUTES.vehicle_detail}/${vehicle?.id}`);
  }, [dispatch, vehicle, history]);

    const onUpdateFirmware = useCallback((e) => {
      e.domEvent.stopPropagation(); 
        dispatch(setSelectedVehicle(vehicle));
        dispatch(setModalName("firmware_vehicle"));
    }, [dispatch, vehicle]);

    const onMqttServerChange = useCallback((e) => {
      e.domEvent.stopPropagation(); 
        dispatch(setSelectedVehicle(vehicle));
        dispatch(setModalName("change_mqtt_server"));
    }, [dispatch, vehicle]);
  const onClickLimpMode = useCallback((e) => {
    e.domEvent.stopPropagation();
    dispatch(setSelectedVehicle(vehicle));
    dispatch(setModalName("limp_mode"));
  }, [dispatch, vehicle]);

  const onClickRemoteLock = useCallback((e) => {
    e.domEvent.stopPropagation();
    dispatch(setSelectedVehicle(vehicle));
    dispatch(setModalName("remote_lock"));
  }, [dispatch, vehicle]);

  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item key="1" onClick={onVehicleDetail}>
          Vehicle Details
        </Menu.Item>
        <Menu.Item key="2" className="firmware-action" onClick={onUpdateFirmware}>
          Update Firmware
        </Menu.Item>
        {userType == 1 || userType == 2 && <Menu.Item key="3" className="mqtt-action" onClick={onMqttServerChange}>
          Change Server
        </Menu.Item> }
        <Menu.Item key="2" onClick={onClickLimpMode}>
          {vehicle?.isLimpModeOn ? "Turn Limp Mode OFF" : "Turn Limp Mode ON"}
        </Menu.Item>
        <Menu.Item key="3" onClick={onClickRemoteLock}>
          {vehicle?.isRemoteLock ? "Turn Vehicle ON" : "Turn Vehicle OFF"}
        </Menu.Item>
        <Menu.Item key="4" className="delete-action" onClick={onDelete}>
          Archive
        </Menu.Item>

      </Menu>
    ),
    [onDelete, onEditShift, onVehicleDetail]
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      
      <a className="ant-dropdown-link"  onClick={(e) => e.stopPropagation()}>{actionMenu}</a>
    </Dropdown>
  );
}
